// src/shared/ui/ScoreChip.jsx — promoted from pages/sow-history/ScoreChip.jsx
// once SOW Analysis Viewer needed the exact same thing.
//
// Small reusable 0-100 score indicator, colored via getScoreColor's tier
// scale (green/blue/amber/orange/red) -- used as an inline chip in list
// columns (size="sm") and as bigger score cards in detail views
// (size="lg"). The kit's own ScoreRing/ScoreBar are dark-theme-only
// (hardcoded text-white/navy-*), which doesn't fit white SurfaceCard/Modal
// surfaces, so this reuses just the color-scale utility instead of those
// components.

import PropTypes from "prop-types";
import { getScoreColor } from "../utils/colorScales";

export default function ScoreChip({ score, label, size = "sm" }) {
  const { color, bgColor } = getScoreColor(score);
  const display = typeof score === "number" ? Math.round(score) : "—";

  if (size === "lg") {
    return (
      <div
        className="flex-1 min-w-[130px] rounded-xl border p-4 text-center"
        style={{ borderColor: color, backgroundColor: bgColor }}
      >
        <p className="text-xs text-muted mb-1">{label}</p>
        <p className="text-2xl font-bold" style={{ color }}>
          {display}
        </p>
      </div>
    );
  }

  return (
    <span
      className="inline-flex items-center justify-center rounded-full px-2.5 py-1 text-xs font-semibold min-w-[2.5rem]"
      style={{ color, backgroundColor: bgColor }}
    >
      {display}
    </span>
  );
}

ScoreChip.propTypes = {
  score: PropTypes.number,
  label: PropTypes.string,
  size: PropTypes.oneOf(["sm", "lg"]),
};
